import { useState, useCallback, useEffect } from "react";
import { toast } from "react-toastify";
import apiClient from "utils/apiClient";
import { OLITASK_SERVICE_BASE_URL } from "constants";
import { olreadiaService } from "services/olreadiaService";

const BASE_URL = `${OLITASK_SERVICE_BASE_URL}/api/v1/admin/helper-requests`;
const STATS_URL = `${OLITASK_SERVICE_BASE_URL}/api/v1/admin/helper-requests/stats`;
export default function useHelperRequests() {
  const authToken = sessionStorage.getItem("authToken");

  const [requests, setRequests] = useState([]);
  const [stats, setStats] = useState(null);
  const [helperProfile, setHelperProfile] = useState(null);

  const [loading, setLoading] = useState(false);
  const [initialLoad, setInitialLoad] = useState(true);

  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [totalPages, setTotalPages] = useState(1);
  const [totalElements, setTotalElements] = useState(0);

  const [status, setStatus] = useState(null);
  const [query, setQuery] = useState("");

  const toGenderText = (value) => {
    if (value === null || value === undefined) return null;
    const text = String(value).trim();
    return text ? text : null;
  };

  const extractGender = (item, helperProfile) => {
    return (
      toGenderText(item?.gender) ||
      toGenderText(item?.sex) ||
      toGenderText(item?.genderType) ||
      toGenderText(item?.userGender) ||
      toGenderText(item?.profile?.gender) ||
      toGenderText(item?.helperProfile?.gender) ||
      toGenderText(helperProfile?.gender) ||
      toGenderText(helperProfile?.sex) ||
      null
    );
  };

  const handleError = (err, action = "operation") => {
    let message = "Something went wrong";
    if (err.response) {
      message = err.response.data?.message || err.response.statusText;
    }
    toast.error(message);
    console.error(action, err);
  };

  // fetch requests
  const fetchRequests = useCallback(async () => {
    if (!authToken) return;

    setLoading(true);

    try {
      const res = await apiClient.get(
        `${BASE_URL}?page=${page}&size=${pageSize}` +
          (status ? `&status=${status}` : "") +
          (query ? `&q=${query}` : "")
      );

      const content = res.data?.content || [];
     
      setRequests(
        content.map((row) => {
          const gender = extractGender(row);
          return gender ? { ...row, gender } : row;
        }),
      );
      setTotalPages(res.data?.totalPages || 1);
      setTotalElements(res.data?.totalElements || 0);
    } catch (err) {
      handleError(err, "fetch helper requests");
    } finally {
      setLoading(false);
      setInitialLoad(false);
    }
  }, [authToken, page, pageSize, status, query]);

  // fetch stats
  const fetchStats = useCallback(async () => {
    if (!authToken) return;

    try {
      const res = await apiClient.get(STATS_URL);
      setStats(res.data);
    } catch (err) {
      handleError(err, "fetch stats");
    }
  }, [authToken]);

  // update status
  const updateHelperStatus = useCallback(
    async (userId, payload) => {
      if (!authToken) return;

      try {
        await apiClient.put(
          `${BASE_URL}/${userId}/status`,
          payload
        );

        toast.success("Status updated");

        fetchRequests();
        fetchStats();
      } catch (err) {
        handleError(err, "update status");
      }
    },
    [authToken]
  );


  const getHelperRequestById = useCallback(
    async (id) => {
      if (!authToken || !id) return;

      setLoading(true);

      try {
        const data = await olreadiaService.helperProfiles.get(id);

        setHelperProfile(data);
        return data;
      } catch (err) {
        handleError(err, "fetch helper profile");
      } finally {
        setLoading(false);
      }
    },
    [authToken]
  );


  useEffect(() => {
    if (authToken) {
      fetchRequests();
      fetchStats();
    }
  }, [authToken, fetchRequests, fetchStats]);

  return {
    requests,
    stats,

    loading,
    initialLoad,

    page,
    pageSize,
    totalPages,
    totalElements,

    status,
    query,
    helperProfile,

    setPage,
    setPageSize,
    setStatus,
    setQuery,

    fetchRequests,
    fetchStats,
    updateHelperStatus,

    getHelperRequestById
  };
}
